import { config } from '@abyss/web/tools/config';
import React, { FC, Fragment, PropsWithChildren } from 'react';
import { Env } from './types';
import { FEATURE_FLAGS } from './FEATURE_FLAGS_CONFIG';
import { isUnitTestEnv } from './isUnitTestEnv';

type FeatureFlagKeys = keyof typeof FEATURE_FLAGS;
interface Props extends PropsWithChildren {
  feature: FeatureFlagKeys;
}

export const isFeatureEnabled = (flag: FeatureFlagKeys): boolean => {
  const env = config('ENV_VAR') as Env;
  return isUnitTestEnv || !!FEATURE_FLAGS[flag][env];
};

export const WhenFeatureEnabled: FC<Props> = ({ feature, children }: Props) => {
  return isFeatureEnabled(feature) ? (
    <Fragment>{children}</Fragment>
  ) : (
    <Fragment />
  );
};
